import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import {
  ExtranetLayoutComponent
} from '../../shared/standalone-components/page-layouts/extranet/extranet-layout/extranet-layout.component';
import {ReportInconsistentPscComponent} from './report-inconsistent-psc/report-inconsistent-psc.component';
import {AboutComponent} from './about/about.component';
import {StandardsComponent} from './standards/standards.component';
import {FaqComponent} from './faq/faq.component';
import {ContactComponent} from './contact/contact.component';
import {PrivacyComponent} from './legals/privacy/privacy.component';
import {
  RoutedLayoutSharedComponent
} from '../../shared/standalone-components/page-layouts/extranet/routed-layout-shared/routed-layout-shared.component';

const routes: Routes = [
  {
    path: '',
    component: ExtranetLayoutComponent,
    children: [
      { path: '', component: HomeComponent, title: 'Nigeria\'s Beneficial Ownership Register (BOR)' },
      { path: 'report-psc', component: ReportInconsistentPscComponent, title: 'Report Inconsistent PSC Information | Beneficial Ownership Register (BOR)' },
      { path: 'about', component: AboutComponent, title: 'About Nigeria\'s Beneficial Ownership Register (BOR)' },
      { path: 'standards', component: StandardsComponent, title: 'BOR Standards | Beneficial Ownership Register (BOR)' },
      { path: 'faq', component: FaqComponent, title: 'FAQs | Beneficial Ownership Register (BOR)' },
      { path: 'contact', component: ContactComponent, title: 'Contact Us | Beneficial Ownership Register (BOR)' },
      {
        path: 'legals',
        component: RoutedLayoutSharedComponent,
        children: [
          { path: 'privacy', component: PrivacyComponent, title: 'Privacy Policy | Beneficial Ownership Register (BOR)' },
          { path: '', pathMatch: 'full', redirectTo: '/' },
        ]
      },
      {
        path: 'search',
        title: 'Search | Beneficial Ownership Register (BOR)',
        loadChildren: () =>
          import('./search/search.module').then(
            (m) => m.SearchModule
          ),
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExtranetRoutingModule {}
